import { emptyReferenceMapCoreCfn } from './empty-reference-map-core.cfn';
import { InternalReferenceMap } from '../../shared.types';

export const emptyInternalReferenceMapCfn = (): InternalReferenceMap => {
	return {
		id: () => { return null },
		...emptyReferenceMapCoreCfn()
	};
};
